export const FETCH_ALL_AREAS_REQUEST='FETCH_ALL_AREAS_REQUEST'
export const FETCH_ALL_AREAS_SUCCESS='FETCH_ALL_AREAS_SUCCESS'
export const FETCH_ALL_AREAS_FAILURE='FETCH_ALL_AREAS_FAILURE'

export const FILTER_AREA_REQUEST='FILTER_AREA_REQUEST'
export const FILTER_AREA_SUCCESS='FILTER_AREA_SUCCESS'
export const FILTER_AREA_FAILURE='FILTER_AREA_FAILURE'